import AuditLog from '@/modules/audit-log/pages/AuditLog'
import CampaignAuditLog from '@/modules/audit-log/pages/CampaignAuditLog'
import LiveActivityAuditLog from '@/modules/audit-log/pages/LiveActivityAuditLog'

export default [
  {
    name: 'AuditLog',
    path: '/audit-log',
    component: AuditLog,
    meta: {
      auth: ['viewAuditLogMenu'],
      title: 'AuditLog_Title'
    },
    children: [
      {
        name: 'CampaignAuditLog',
        path: 'campaigns',
        component: CampaignAuditLog,
        meta: {
          auth: ['viewAuditLogMenu'],
          title: 'AuditLog_Title'
        }
      },
      {
        name: 'LiveActivityAuditLog',
        path: 'live-activity',
        component: LiveActivityAuditLog,
        meta: {
          projectFeatures: {
            items: ['openLiveActivities'],
            notFound: true
          },
          auth: ['viewAuditLogMenu'],
          title: 'AuditLog_Title'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/audit-log/router/index.js